const STATUS_STYLES = {
  connected: {
    label: 'Connected',
    cls: 'bg-emerald-50 text-emerald-700 ring-emerald-200/80 dark:bg-emerald-950/50 dark:text-emerald-400 dark:ring-emerald-800/60',
    dot: 'bg-emerald-500',
  },
  available: {
    label: 'Available',
    cls: 'bg-blue-50 text-blue-700 ring-blue-200/80 dark:bg-blue-950/50 dark:text-blue-400 dark:ring-blue-800/60',
    dot: 'bg-blue-500',
  },
  pending: {
    label: 'Pending',
    cls: 'bg-amber-50 text-amber-800 ring-amber-200/80 dark:bg-amber-950/50 dark:text-amber-400 dark:ring-amber-800/60',
    dot: 'bg-amber-500',
  },
  in_setup: {
    label: 'In Setup',
    cls: 'bg-amber-50 text-amber-800 ring-amber-200/80 dark:bg-amber-950/50 dark:text-amber-400 dark:ring-amber-800/60',
    dot: 'bg-amber-500',
  },
  inactive: {
    label: 'Inactive',
    cls: 'bg-slate-100 text-slate-600 ring-slate-200/80 dark:bg-slate-800 dark:text-slate-400 dark:ring-slate-700/80',
    dot: 'bg-slate-400',
  },
  coming_soon: {
    label: 'Coming Soon',
    cls: 'bg-violet-50 text-violet-700 ring-violet-200/80 dark:bg-violet-950/50 dark:text-violet-400 dark:ring-violet-800/60',
    dot: 'bg-violet-400',
  },
}

export default function StatusBadge({ status, compact = false }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES.inactive
  return (
    <span
      className={[
        'inline-flex items-center gap-1.5 rounded-full font-semibold ring-1',
        s.cls,
        compact ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-[11px]',
      ].join(' ')}
    >
      <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${s.dot}`} aria-hidden />
      {s.label}
    </span>
  )
}
